import { useEffect, useRef, useState } from "react";

import ProgressIndicatorView, {
  ProgressIndicatorDOMProps as _ProgressIndicatorDOMProps,
  ProgressIndicatorProps as _ProgressIndicatorProps,
} from "./progress-indicator-view";

const MINIMUM_DISPLAY_TIME = 300;

export type ProgressIndicatorDOMProps = _ProgressIndicatorDOMProps;
export interface ProgressIndicatorProps extends _ProgressIndicatorProps {}

const timeoutCB = (toRef: any, sh: any, setShn: (s: any) => void) => {
  if (toRef.current && !sh) {
    // if delayed hide was not cancelled, update state
    setShn(undefined);
    toRef.current = undefined;
  }
};
export default function ProgressIndicator(props: _ProgressIndicatorProps) {
  const { show, ...other } = props;
  // The actual view state
  // time of render with show:true
  const [shown, setShown] = useState<number | undefined>();
  // delayed hide reference
  const timeoutRef = useRef<NodeJS.Timeout | undefined>(undefined);
  useEffect(() => {
    if (show) {
      // input was true, store time and update view state if needed.
      setShown(new Date().getTime());
      if (timeoutRef.current) {
        // Cancel delayed hide
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    } else if (!timeoutRef.current) {
      timeoutRef.current = setTimeout(() => {
        timeoutCB(timeoutRef, 0, setShown);
      }, MINIMUM_DISPLAY_TIME);
    }
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = undefined;
      }
    };
  }, [show]);
  return (
    <ProgressIndicatorView show={shown !== undefined ? shown : 0} {...other} />
  );
}
